<template>
    <!-- style="margin-top: -58px !important;" -->
    <div class="card" >
        <div class="card-header">
            <h3 class="my-0">Columnas personalizadas</h3>
        </div>
        <div class="card-body">

            <el-collapse v-model="activeDeafult">
                <el-collapse-item title="Columnas de cabecera de factura, boleta, nota de venta y cotización" name="1">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <th>#</th>
                                <th>Nombre Original</th>
                                <th>Título en Negrita</th>
                                <th>Contenido en Negrita</th>
                                <th>Nombre en PDF</th>
                                <!-- <th>Ancho</th> -->
                                <th class="text-end">Mostrar</th>
                            </thead>
                            <tbody>
                                <tr v-for="(column, index) in columns_header" :key="column.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{ column.origin_name }}
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.header_in_bold"
                                            :disabled="column.value === 'image' || column.value === 'company_address'"
                                            @change="updateRecord(column.id, 'header_in_bold', $event)"
                                        >
                                            <template v-if="column.header_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.content_in_bold"
                                            :disabled="column.value === 'image'"
                                            @change="updateRecord(column.id, 'content_in_bold', $event)"
                                        >
                                            <template v-if="column.content_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td>
                                        <el-input
                                            v-model="column.name"
                                            placeholder="Nombre en PDF"
                                            @input="updateRecord(column.id, 'name', $event)"
                                            :disabled="column.value === 'image' || column.value === 'company_address'"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-switch
                                            v-model="column.is_visible"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'is_visible', $event)"
                                        ></el-switch>
                                        <template v-if="column.value === 'image'">
                                            <br>
                                            <el-checkbox label="A4/A5"
                                                v-model="column.show_in_pdf"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_in_pdf', $event)"
                                            ></el-checkbox>
                                            <el-checkbox label="Tickets"
                                                v-model="column.show_in_pdfticket"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_in_pdfticket', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox
                                                v-model="column.large_logo"
                                                size="mini"
                                                @change="updateRecord(column.id, 'large_logo', $event)"
                                            >
                                                Logo grande
                                                <el-tooltip content="Factura/Boleta, Nota de Venta y Cotización en formato A4, plantilla gestion_default" placement="top">
                                                    <i class="fa fa-info-circle"></i>
                                                </el-tooltip>
                                            </el-checkbox>
                                        </template>
                                        <template v-if="allowed_list.includes(column.value)">
                                            <br>
                                            <el-checkbox label="Factura y boleta"
                                                v-model="column.show_invoice"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_invoice', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Nota de venta"
                                                v-model="column.show_sale_note"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_sale_note', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Cotización"
                                                v-model="column.show_quotation"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_quotation', $event)"
                                                :disabled="column.value === 'purchase_order'"
                                            ></el-checkbox>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                    <h5 class="my-2" style="font-weight: 600;">Empresa
                        <el-tooltip content="Empresa que adquiere el sistema"
                            placement="top"
                        >
                            <i class="fa fa-info-circle"></i>
                        </el-tooltip>
                    </h5>
                    <div class="row">
                        <div class="col-12">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <th>#</th>
                                        <th>Nombre Original</th>
                                        <th>Título en Negrita</th>
                                        <th>Contenido en Negrita</th>
                                        <th>Nombre en PDF</th>
                                        <th>
                                            A4
                                            <el-tooltip content="Cuando no tenga valor el campo, tomará el valor original"
                                                placement="top"
                                            >
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                            <br>Fuente del contenido
                                            <br>
                                            <small>Factura y Boleta</small>
                                        </th>
                                        <th>
                                            Ticket 80
                                            <el-tooltip content="Cuando no tenga valor el campo, tomará el valor original"
                                                placement="top"
                                            >
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                            <br>Fuente del contenido
                                            <br>
                                            <small>Factura y Boleta</small>
                                        </th>
                                        <th>A4
                                            <br>Color
                                            <br><small>Factura y Boleta</small>
                                        </th>
                                        <th>A4
                                            <br>Color
                                            <br><small>Nota de Venta</small>
                                        </th>
                                        <th>A4
                                            <br>Color
                                            <br><small>Cotización</small>
                                        </th>
                                        <th class="text-end">Mostrar</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(column, index) in columns_header_client" :key="column.id">
                                            <td>{{ index + 1 }}</td>
                                            <td>
                                                {{ column.origin_name }}
                                            </td>
                                            <td class="text-center">
                                                <el-checkbox
                                                    v-model="column.header_in_bold"
                                                    :disabled="column.value === 'image' || column.value === 'company_address' || column.value === 'document_type'"
                                                    @change="updateRecord(column.id, 'header_in_bold', $event)"
                                                >
                                                    <template v-if="column.header_in_bold">
                                                        Sí
                                                    </template>
                                                    <template v-else>
                                                        No
                                                    </template>
                                                </el-checkbox>
                                            </td>
                                            <td class="text-center">
                                                <el-checkbox
                                                    v-model="column.content_in_bold"
                                                    :disabled="column.value === 'image' || column.value === 'document_type'"
                                                    @change="updateRecord(column.id, 'content_in_bold', $event)"
                                                >
                                                    <template v-if="column.content_in_bold">
                                                        Sí
                                                    </template>
                                                    <template v-else>
                                                        No
                                                    </template>
                                                </el-checkbox>
                                            </td>
                                            <td>
                                                <el-input
                                                    v-model="column.name"
                                                    placeholder="Nombre en PDF"
                                                    @input="updateRecord(column.id, 'name', $event)"
                                                    :disabled="column.value === 'image' || column.value === 'company_address' || column.value === 'document_type'"
                                                ></el-input>
                                            </td>

                                            <td>
                                                <template v-if="column.value === 'company_name' || column.value === 'company_trade_name'">
                                                    <el-input v-model="column.font_size_a4" placeholder=""
                                                        @input="updateRecord(column.id, 'font_size_a4', $event)"
                                                    ></el-input>
                                                </template>
                                            </td>
                                            <td>
                                                <template v-if="column.value === 'company_name' || column.value === 'company_trade_name'">
                                                    <el-input v-model="column.font_size_ticket_80" placeholder=""
                                                        @input="updateRecord(column.id, 'font_size_ticket_80', $event)"
                                                    ></el-input>
                                                </template>
                                            </td>
                                            <td>
                                                <el-color-picker v-if="showColorCompany(column)"
                                                    v-model="column.color"
                                                    @change="updateRecord(column.id, 'color', $event)"
                                                ></el-color-picker>
                                            </td>
                                            <td>
                                                <el-color-picker v-if="showColorCompany(column)"
                                                    v-model="column.color_sale_note"
                                                    @change="updateRecord(column.id, 'color_sale_note', $event)"
                                                ></el-color-picker>
                                            </td>
                                            <td>
                                                <el-color-picker v-if="showColorCompany(column)"
                                                    v-model="column.color_quotation"
                                                    @change="updateRecord(column.id, 'color_quotation', $event)"
                                                ></el-color-picker>
                                            </td>
                                            <td>
                                                <el-switch v-if="column.value !== 'document_type'"
                                                    v-model="column.is_visible"
                                                    active-text="Si"
                                                    inactive-text="No"
                                                    @change="updateRecord(column.id, 'is_visible', $event)"
                                                ></el-switch>
                                                <template v-if="column.value === 'image'">
                                                    <br>
                                                    <el-checkbox label="A4/A5"
                                                        v-model="column.show_in_pdf"
                                                        size="mini"
                                                        @change="updateRecord(column.id, 'show_in_pdf', $event)"
                                                    ></el-checkbox>
                                                    <el-checkbox label="Tickets"
                                                        v-model="column.show_in_pdfticket"
                                                        size="mini"
                                                        @change="updateRecord(column.id, 'show_in_pdfticket', $event)"
                                                    ></el-checkbox>
                                                    <br>
                                                    <el-checkbox
                                                        v-model="column.large_logo"
                                                        size="mini"
                                                        @change="updateRecord(column.id, 'large_logo', $event)"
                                                    >
                                                        Logo grande
                                                        <el-tooltip content="Factura/Boleta, Nota de Venta y Cotización en formato A4, plantilla gestion_default" placement="top">
                                                            <i class="fa fa-info-circle"></i>
                                                        </el-tooltip>
                                                    </el-checkbox>
                                                </template>
                                                <template v-if="allowed_list.includes(column.value)">
                                                    <br>
                                                    <el-checkbox label="Factura y boleta"
                                                        v-model="column.show_invoice"
                                                        size="mini"
                                                        @change="updateRecord(column.id, 'show_invoice', $event)"
                                                    ></el-checkbox>
                                                    <br>
                                                    <el-checkbox label="Nota de venta"
                                                        v-model="column.show_sale_note"
                                                        size="mini"
                                                        @change="updateRecord(column.id, 'show_sale_note', $event)"
                                                    ></el-checkbox>
                                                    <br>
                                                    <el-checkbox label="Cotización"
                                                        v-model="column.show_quotation"
                                                        size="mini"
                                                        @change="updateRecord(column.id, 'show_quotation', $event)"
                                                        :disabled="column.value === 'purchase_order'"
                                                    ></el-checkbox>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </el-collapse-item>

                <el-collapse-item title="Columnas listado de factura, boleta, nota de venta y cotización" name="2">
                    <!-- <div style="display: flex; justify-content: end; width: 100%;">
                        <el-dropdown>
                            <el-button type="primary">
                                Mostrar/Ocultar columnas<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item v-for="(item, index) in listColumnsHideShowCPE"
                                    :key="index"
                                >
                                    <el-checkbox :label="item.label"
                                        v-model="item.show"
                                        @change="updateRecordListColumnsHideShowCPE(item.value, item.show)"
                                    ></el-checkbox>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div> -->

                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre Original</th>
                                    <th class="text-center">Título en Negrita</th>
                                    <th class="text-center">Contenido en Negrita</th>
                                    <th>Nombre en PDF</th>
                                    <th>Ancho (%)</th>
                                    <th>Orden</th>
                                    <th>Alinear</th>
                                    <th>
                                        A5
                                        <el-tooltip content="Cuando no tenga valor el campo, tomará el valor original"
                                            placement="top"
                                        >
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                        <br>Fuente del contenido
                                    </th>
                                    <th>
                                        A4
                                        <el-tooltip content="Cuando no tenga valor el campo, tomará el valor original"
                                            placement="top"
                                        >
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                        <br>Fuente del contenido
                                    </th>
                                    <th>
                                        80MM
                                        <el-tooltip content="Cuando no tenga valor el campo, tomará el valor original"
                                            placement="top"
                                        >
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                        <br>Fuente del contenido
                                    </th>
                                    <th>
                                        58MM
                                        <el-tooltip content="Cuando no tenga valor el campo, tomará el valor original"
                                            placement="top"
                                        >
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                        <br>Fuente del contenido
                                    </th>
                                    <th>
                                        50MM
                                        <el-tooltip content="Cuando no tenga valor el campo, tomará el valor original"
                                            placement="top"
                                        >
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                        <br>Fuente del contenido
                                    </th>
                                    <th class="text-end">Mostrar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(column, index) in columns_table" :key="column.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{ column.origin_name }}
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.header_in_bold"
                                            @change="updateRecord(column.id, 'header_in_bold', $event)"
                                        >
                                            <template v-if="column.header_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.content_in_bold"
                                            @change="updateRecord(column.id, 'content_in_bold', $event)"
                                            :disabled="column.value === 'item_image'"
                                        >
                                            <template v-if="column.content_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td>
                                        <el-input
                                            v-model="column.name"
                                            placeholder="Nombre en PDF"
                                            @input="updateRecord(column.id, 'name', $event)"
                                            style="width: 180px;"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-input
                                            v-model="column.width"
                                            @input="updateRecord(column.id, 'width', $event)"
                                            style="width: 80px;"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-select v-model="column.order"
                                            @change="updateRecordOrder(column.id, 'order', $event)"
                                            style="width: 70px;"
                                        >
                                            <el-option
                                                v-for="option in count_columns_table"
                                                :key="option"
                                                :label="option"
                                                :value="option"
                                                 
                                            ></el-option>
                                        </el-select>
                                    </td>
                                    <td>
                                        <el-select v-model="column.align"
                                            @change="updateRecord(column.id, 'align', $event)"
                                            style="width: 150px;"
                                        >
                                            <el-option
                                                v-for="option in align_array"
                                                :key="option.value"
                                                :label="option.text"
                                                :value="option.value"
                                                 
                                            ></el-option>
                                        </el-select>
                                    </td>
                                    <td>
                                        <el-input v-model="column.font_size_a5" placeholder=""
                                            @input="updateRecord(column.id, 'font_size_a5', $event)"
                                            style="width: 80px;"
                                            :disabled="column.value === 'item_image'"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-input v-model="column.font_size_a4" placeholder=""
                                            @input="updateRecord(column.id, 'font_size_a4', $event)"
                                            style="width: 80px;"
                                            :disabled="column.value === 'item_image'"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-input v-model="column.font_size_ticket_80" placeholder=""
                                            @input="updateRecord(column.id, 'font_size_ticket_80', $event)"
                                            style="width: 80px;"
                                            :disabled="column.value === 'item_image'"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-input v-model="column.font_size_ticket_58" placeholder=""
                                            @input="updateRecord(column.id, 'font_size_ticket_58', $event)"
                                            style="width: 80px;"
                                            :disabled="column.value === 'item_image'"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-input v-model="column.font_size_ticket_50" placeholder=""
                                            @input="updateRecord(column.id, 'font_size_ticket_50', $event)"
                                            style="width: 80px;"
                                            :disabled="column.value === 'item_image'"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-switch
                                            v-model="column.is_visible"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'is_visible', $event)"
                                        ></el-switch>
                                        <template v-if="showChecksInColumnsCPE(column.value)">
                                            <br>
                                            <el-checkbox label="Factura y boleta"
                                                v-model="column.show_invoice"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_invoice', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Nota de venta"
                                                v-model="column.show_sale_note"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_sale_note', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Cotización"
                                                v-model="column.show_quotation"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_quotation', $event)"
                                            ></el-checkbox>
                                            <template v-if="column.value === 'item_image'">
                                                <div class="form-group">
                                                    <label class="control-label">
                                                        Ancho (px)
                                                    </label>
                                                    <el-input
                                                        v-model="column.width_item_image"
                                                        @input="updateRecord(column.id, 'width_item_image', $event)"
                                                    ></el-input>
                                                </div>
                                                <div class="form-group">
                                                    <label class="control-label">
                                                        Alto (px)
                                                    </label>
                                                    <el-input
                                                        v-model="column.height_item_image"
                                                        @input="updateRecord(column.id, 'height_item_image', $event)"                                                
                                                    ></el-input>
                                                </div>
                                            </template>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <h5 class="my-2" style="font-weight: 600;">Hotel</h5>
                    <div class="row">
                        <div class="col-12 col-lg-7">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <th>Nombre Original</th>
                                        <th class="text-center">Título en Negrita</th>
                                        <th class="text-center">Contenido en Negrita</th>
                                        <th>Nombre en PDF</th>
                                        <th>Ancho (%)</th>
                                        <th>Alinear</th>
                                        <th class="text-end">Mostrar</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(column, index) in columns_table_hotel_left" :key="column.id">
                                            <td>
                                                {{ column.origin_name }}
                                            </td>
                                            <td class="text-center">
                                                <el-checkbox
                                                    v-model="column.header_in_bold"
                                                    @change="updateRecord(column.id, 'header_in_bold', $event)"
                                                >
                                                    <template v-if="column.header_in_bold">
                                                        Sí
                                                    </template>
                                                    <template v-else>
                                                        No
                                                    </template>
                                                </el-checkbox>
                                            </td>
                                            <td class="text-center">
                                                <el-checkbox
                                                    v-model="column.content_in_bold"
                                                    @change="updateRecord(column.id, 'content_in_bold', $event)"
                                                >
                                                    <template v-if="column.content_in_bold">
                                                        Sí
                                                    </template>
                                                    <template v-else>
                                                        No
                                                    </template>
                                                </el-checkbox>
                                            </td>
                                            <td>
                                                <el-input
                                                    v-model="column.name"
                                                    placeholder="Nombre en PDF"
                                                    @input="updateRecord(column.id, 'name', $event)"
                                                ></el-input>
                                            </td>
                                            <td>
                                                <el-input
                                                    v-model="column.width"
                                                    @input="updateRecord(column.id, 'width', $event)"
                                                ></el-input>
                                            </td>
                                            <td>
                                                <el-select v-model="column.align"
                                                    @change="updateRecord(column.id, 'align', $event)"
                                                >
                                                    <el-option
                                                        v-for="option in align_array"
                                                        :key="option.value"
                                                        :label="option.text"
                                                        :value="option.value"
                                                        
                                                    ></el-option>
                                                </el-select>
                                            </td>
                                            <td>
                                                <el-switch
                                                    v-model="column.is_visible"
                                                    active-text="Si"
                                                    inactive-text="No"
                                                    @change="updateRecord(column.id, 'is_visible', $event)"
                                                ></el-switch>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="col-12 col-lg-5">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <th>Nombre Original</th>
                                        <th class="text-center">Contenido en Negrita</th>
                                        <th class="text-end">Mostrar</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(column, index) in columns_table_hotel_right" :key="column.id">
                                            <td>
                                                {{ column.origin_name }}
                                            </td>
                                            <td class="text-center">
                                                <el-checkbox
                                                    v-model="column.content_in_bold"
                                                    @change="updateRecord(column.id, 'content_in_bold', $event)"
                                                >
                                                    <template v-if="column.content_in_bold">
                                                        Sí
                                                    </template>
                                                    <template v-else>
                                                        No
                                                    </template>
                                                </el-checkbox>
                                            </td>
                                            <td>
                                                <el-switch
                                                    v-model="column.is_visible"
                                                    active-text="Si"
                                                    inactive-text="No"
                                                    @change="updateRecord(column.id, 'is_visible', $event)"
                                                ></el-switch>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    
                </el-collapse-item>

                <el-collapse-item title="Columnas listado de guías" name="3">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <th>#</th>
                                <th>Nombre Original</th>
                                <th class="text-center">Título en Negrita</th>
                                <th class="text-center">Contenido en Negrita</th>
                                <th>Nombre en PDF</th>
                                <!-- <th>Ancho</th>
                                <th>Orden</th> -->
                                <th>Alinear</th>
                                <th class="text-end">Mostrar</th>
                            </thead>
                            <tbody>
                                <tr v-for="(column, index) in columns_table_dispatch" :key="column.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{ column.origin_name }}
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.header_in_bold"
                                            @change="updateRecord(column.id, 'header_in_bold', $event)"
                                        >
                                            <template v-if="column.header_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.content_in_bold"
                                            @change="updateRecord(column.id, 'content_in_bold', $event)"
                                        >
                                            <template v-if="column.content_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td>
                                        <el-input
                                            v-model="column.name"
                                            placeholder="Nombre en PDF"
                                            @input="updateRecord(column.id, 'name', $event)"
                                        ></el-input>
                                    </td>
                                    <!-- <td>
                                        <el-input
                                            v-model="column.width"
                                            @input="updateRecord(column.id, 'width', $event)"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-select v-model="column.order"
                                            @change="updateRecordOrder(column.id, 'order', $event, true)"
                                        >
                                            <el-option
                                                v-for="option in count_columns_table_dispatch"
                                                :key="option"
                                                :label="option"
                                                :value="option"
                                                 
                                            ></el-option>
                                        </el-select>
                                    </td> -->
                                    <td>
                                        <el-select v-model="column.align"
                                            @change="updateRecord(column.id, 'align', $event)"
                                        >
                                            <el-option
                                                v-for="option in align_array"
                                                :key="option.value"
                                                :label="option.text"
                                                :value="option.value"
                                                 
                                            ></el-option>
                                        </el-select>
                                    </td>
                                    <td>
                                        <el-switch
                                            v-model="column.is_visible"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'is_visible', $event)"
                                        ></el-switch>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="Columnas footer de factura, boleta, nota de venta y cotización" name="4">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <th>#</th>
                                <th>Nombre Original</th>
                                <th>Título en Negrita</th>
                                <th>Contenido en Negrita</th>
                                <th>Nombre en PDF</th>
                                <th class="text-end">Mostrar</th>
                            </thead>
                            <tbody>
                                <tr v-for="(column, index) in columns_footer" :key="column.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{ column.origin_name }}
                                        <template v-if="column.value === 'hash_code' || column.value === 'payment_condition'">
                                            <el-tooltip content="Disponible en factura y boleta" placement="top">
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                        </template>
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.header_in_bold"
                                            @change="updateRecord(column.id, 'header_in_bold', $event)"
                                            :disabled="column.value === 'footer_consulta'"
                                        >
                                            <template v-if="column.header_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.content_in_bold"
                                            @change="updateRecord(column.id, 'content_in_bold', $event)"
                                            :disabled="column.value === 'footer_consulta'"
                                        >
                                            <template v-if="column.content_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td>
                                        <el-input
                                            v-model="column.name"
                                            placeholder="Nombre en PDF"
                                            @input="updateRecord(column.id, 'name', $event)"
                                            :disabled="column.value === 'footer_consulta'"
                                        ></el-input>
                                    </td>
                                    <td>
                                        <el-switch
                                            v-model="column.is_visible"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'is_visible', $event)"
                                        ></el-switch>
                                        <template v-if="footerListMoreOptions.includes(column.value)">
                                            <br>
                                            <el-checkbox label="Factura y boleta"
                                                v-model="column.show_invoice"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_invoice', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Nota de venta"
                                                v-model="column.show_sale_note"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_sale_note', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Cotización"
                                                v-model="column.show_quotation"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_quotation', $event)"
                                            ></el-checkbox>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="Columnas especiales de factura, boleta, nota de venta y cotización" name="5">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <th>#</th>
                                <th>Nombre Original</th>
                                <th>Título en Negrita</th>
                                <th>Contenido en Negrita</th>
                                <th>Nombre en PDF</th>
                                <th class="text-end">Mostrar</th>
                            </thead>
                            <tbody>
                                <tr v-for="(column, index) in columns_special" :key="column.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{ column.origin_name }}
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.header_in_bold"
                                            @change="updateRecord(column.id, 'header_in_bold', $event)"
                                        >
                                            <template v-if="column.header_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.content_in_bold"
                                            @change="updateRecord(column.id, 'content_in_bold', $event)"
                                            :disabled="column.value === 'service_transport'"
                                        >
                                            <template v-if="column.content_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    
                                    <td>
                                        <el-input
                                            v-model="column.name"
                                            placeholder="Nombre en PDF"
                                            @input="updateRecord(column.id, 'name', $event)"
                                        ></el-input>
                                    </td>

                                    <td>
                                        <el-switch
                                            v-model="column.is_visible"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'is_visible', $event)"
                                        ></el-switch>
                                        <template v-if="column.value === 'seller'">
                                            <br>
                                            <el-checkbox label="Factura y boleta"
                                                v-model="column.show_invoice"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_invoice', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Nota de venta"
                                                v-model="column.show_sale_note"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_sale_note', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Cotización"
                                                v-model="column.show_quotation"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_quotation', $event)"
                                            ></el-checkbox>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-collapse-item>

                <el-collapse-item title="Columnas especiales de factura, boleta" name="6">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <th>#</th>
                                <th>Nombre Original</th>
                                <th>Título en Negrita</th>
                                <th>Contenido en Negrita</th>
                                <th>Nombre en PDF</th>
                                <th class="text-end">Mostrar</th>
                            </thead>
                            <tbody>
                                <tr v-for="(column, index) in columns_special_cpe" :key="column.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{ column.origin_name }}
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.header_in_bold"
                                            @change="updateRecord(column.id, 'header_in_bold', $event)"
                                        >
                                            <template v-if="column.header_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    <td class="text-center">
                                        <el-checkbox
                                            v-model="column.content_in_bold"
                                            @change="updateRecord(column.id, 'content_in_bold', $event)"
                                            :disabled="column.value === 'service_transport'"
                                        >
                                            <template v-if="column.content_in_bold">
                                                Sí
                                            </template>
                                            <template v-else>
                                                No
                                            </template>
                                        </el-checkbox>
                                    </td>
                                    
                                    <td>
                                        <el-input
                                            v-model="column.name"
                                            placeholder="Nombre en PDF"
                                            @input="updateRecord(column.id, 'name', $event)"
                                        ></el-input>
                                    </td>

                                    <td>
                                        <el-switch
                                            v-model="column.is_visible"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'is_visible', $event)"
                                        ></el-switch>
                                        <template v-if="column.value === 'seller'">
                                            <br>
                                            <el-checkbox label="Factura y boleta"
                                                v-model="column.show_invoice"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_invoice', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Nota de venta"
                                                v-model="column.show_sale_note"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_sale_note', $event)"
                                            ></el-checkbox>
                                            <br>
                                            <el-checkbox label="Cotización"
                                                v-model="column.show_quotation"
                                                size="mini"
                                                @change="updateRecord(column.id, 'show_quotation', $event)"
                                            ></el-checkbox>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-collapse-item>

                <el-collapse-item name="7">
                    <template slot="title">
                        Diseño de la plantilla
                        <el-tooltip content="Disponible en tamaño A4"
                            placement="top"
                            effect="dark"
                        >
                            <i class="fa fa-info-circle ml-3"></i>
                        </el-tooltip>
                    </template>
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <th>#</th>
                                <th>Nombre</th>
                                <th>Color<br>
                                    <small>Factura y Boleta</small>
                                </th>
                                <th>Mostrar<br>
                                    <small>Factura y Boleta</small>
                                </th>
                                <th>Color<br>
                                    <small>Nota de Venta</small>
                                </th>
                                <th>Mostrar<br>
                                    <small>Nota de Venta</small>
                                </th>
                                <th>Color<br>
                                    <small>Cotización</small>
                                </th>
                                <th>Mostrar<br>
                                    <small>Cotización</small>
                                </th>
                            </thead>
                            <tbody>
                                <tr v-for="(column, index) in columns_design" :key="column.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        {{ column.origin_name }}
                                    </td>
                                    <td>
                                        <el-color-picker v-if="isBackgroundOrColor(column)"
                                            v-model="column.color"
                                            @change="updateRecord(column.id, 'color', $event)"
                                        ></el-color-picker>
                                    </td>
                                    <td>
                                        <el-switch
                                            v-if="!isBackgroundOrColor(column)"
                                            v-model="column.is_visible"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'is_visible', $event)"
                                        ></el-switch>
                                    </td>
                                    <td>
                                        <el-color-picker v-if="isBackgroundOrColor(column)"
                                            v-model="column.color_sale_note"
                                            @change="updateRecord(column.id, 'color_sale_note', $event)"
                                        ></el-color-picker>
                                    </td>
                                    <td>
                                        <el-switch
                                            v-if="!isBackgroundOrColor(column)"
                                            v-model="column.show_sale_note"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'show_sale_note', $event)"
                                        ></el-switch>
                                    </td>
                                    <td>
                                        <el-color-picker v-if="isBackgroundOrColor(column)"
                                            v-model="column.color_quotation"
                                            @change="updateRecord(column.id, 'color_quotation', $event)"
                                        ></el-color-picker>
                                    </td>
                                    <td>
                                        <el-switch
                                            v-if="!isBackgroundOrColor(column)"
                                            v-model="column.show_quotation"
                                            active-text="Si"
                                            inactive-text="No"
                                            @change="updateRecord(column.id, 'show_quotation', $event)"
                                        ></el-switch>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </el-collapse-item>
            </el-collapse>

            
        </div>
    </div>
</template>

<script>

export default {
    props: ['typeUser'],

    data() {
        return {
            activeDeafult: ['1'],
            resource: 'document-columns',
            columns_header: [],
            columns_header_client: [],
            columns_table: [],
            columns_table_dispatch: [],
            columns_table_hotel_left: [],
            columns_table_hotel_right: [],
            columns_footer: [],
            columns_special: [],
            columns_special_cpe: [],
            columns_design: [],
            count_columns_table: 0,
            count_columns_table_dispatch: 0,
            timer: null,
            align_array: [
                {
                    text: 'Izquierda',
                    value: 'left'
                },
                {
                    text: 'Centro',
                    value: 'center'
                },
                {
                    text: 'Derecha',
                    value: 'right'
                },
            ],
            allowed_list: [
                'company_address',
                'company_trade_name',
                'company_name',
                'company_number',
                'purchase_order',
                'total_quantity',
                'model',
                'branch_address',
                'telephone',
                'email',
            ],
            footerListMoreOptions: [
                'total_unaffected',
                'total_exonerated',
                'total_taxed',
                'total_igv',
                'terms_and_conditions',
                'payments_balance',
            ],
            listColumnsHideShowCPE: [
                {
                    value: 'font_size_a5',
                    label: 'A5 Fuente del contenido',
                    show: false
                },
                {
                    value: 'font_size_a4',
                    label: 'A4 Fuente del contenido',
                    show: false
                },
                {
                    value: 'font_size_ticket_80',
                    label: 'Ticket 80mm Fuente del contenido',
                    show: false
                },
                {
                    value: 'font_size_ticket_58',
                    label: 'Ticket 58mm Fuente del contenido',
                    show: false
                },
                {
                    value: 'font_size_ticket_50',
                    label: 'Ticket 50mm Fuente del contenido',
                    show: false
                },
            ]
        }
    },

    computed: {
        visibleA5() {
            const item = this.listColumnsHideShowCPE.find(i => i.value === 'font_size_a5').show
            return item
        },
        visibleA4() {
            const item = this.listColumnsHideShowCPE.find(i => i.value === 'font_size_a4').show
            return item
        },
        visibleTicket80() {
            const item = this.listColumnsHideShowCPE.find(i => i.value === 'font_size_ticket_80').show
            return item
        },
        visibleTicket58() {
            const item = this.listColumnsHideShowCPE.find(i => i.value === 'font_size_ticket_58').show
            return item
        },
        visibleTicket50() {
            const item = this.listColumnsHideShowCPE.find(i => i.value === 'font_size_ticket_50').show
            return item
        }
    },

    created() {
        this.getData()
    },

    methods: {
        getData() {
            this.$http.get(`${this.resource}/records`)
                .then((response) => {
                    const columns = response.data.data.map(column => {
                        return {
                            id: column.id,
                            origin_name: column.origin_name,
                            name: column.name,
                            width: column.width,
                            order: column.order,
                            is_visible: Boolean(column.is_visible),
                            space: column.space,
                            value: column.value,
                            align: column.align,
                            show_in_pdf: Boolean(column.show_in_pdf) || false,
                            show_in_pdfticket: Boolean(column.show_in_pdfticket) || false,
                            header_in_bold: Boolean(column.header_in_bold) || false,
                            content_in_bold: Boolean(column.content_in_bold) || false,
                            large_logo: Boolean(column.large_logo) || false,
                            show_invoice: Boolean(column.show_invoice) || false,
                            show_quotation: Boolean(column.show_quotation) || false,
                            show_sale_note: Boolean(column.show_sale_note) || false,
                            height_item_image: column.height_item_image,
                            width_item_image: column.width_item_image,
                            font_size_a5: column.font_size_a5,
                            font_size_a4: column.font_size_a4,
                            font_size_ticket_80: column.font_size_ticket_80,
                            font_size_ticket_58: column.font_size_ticket_58,
                            font_size_ticket_50: column.font_size_ticket_50,
                            color: column.color,
                            color_sale_note: column.color_sale_note,
                            color_quotation: column.color_quotation
                        }
                    })

                    const rows_client = [
                        'company_address',
                        'company_trade_name',
                        'company_name',
                        'company_number',
                        'image',
                        'document_type',
                        'branch_address',
                        'email',
                        'telephone',
                    ]

                    this.columns_header = columns.filter(column => column.space === 'header' && !rows_client.includes(column.value))
                    this.columns_header_client = columns.filter(column => column.space === 'header' && rows_client.includes(column.value))
                    this.columns_table = columns.filter(column => column.space === 'table')
                                                    .filter(column => column.value !== 'date_input' && column.value !== 'time_input' && column.value !== 'date_output' && column.value !== 'time_output')
                                                    .sort((a, b) => {
                                                        return a.order - b.order
                                                    })
                    this.columns_table_dispatch = columns.filter(column => column.space === 'table_dispatch')
                                                    .sort((a, b) => {
                                                        return a.order - b.order
                                                    })
                    this.columns_footer = columns.filter(column => column.space === 'footer' && (
                        column.value === 'total_unaffected' ||
                        column.value === 'total_exonerated' ||
                        column.value === 'total_taxed' ||
                        column.value === 'total_igv' ||
                        column.value === 'total_document' ||
                        column.value === 'total_pagar_sin_dcto' ||
                        column.value === 'prepared_by' ||
                        column.value === 'footer_consulta' ||
                        column.value === 'detraccion_monto_pendiente' ||
                        column.value === 'hash_code' ||
                        column.value === 'payment_condition' ||
                        column.value === 'terms_and_conditions' ||
                        column.value === 'payments' ||
                        column.value === 'payments_balance'
                    ))

                    this.columns_special = columns.filter(column => column.space === 'others' && column.value === 'seller')
                    this.columns_special_cpe = columns.filter(column => column.space === 'others' && column.value !== 'seller')
                    this.columns_design = columns.filter(column => column.space === 'design')

                    this.columns_table_hotel_left = columns.filter(column => column.value === 'date_input' || column.value === 'date_output')
                    this.columns_table_hotel_right = columns.filter(column => column.value === 'time_input' || column.value === 'time_output')

                    this.count_columns_table = this.columns_table.length
                    this.count_columns_table_dispatch = this.columns_table_dispatch.length
                })
        },

        async updateRecord(id, attribute, value) {
            const exceptions = [
                'is_visible',
                'header_in_bold',
                'content_in_bold',
                'show_in_pdf',
                'show_in_pdfticket',
                'large_logo',
                'show_invoice',
                'show_quotation',
                'show_sale_note',
            ]
            if (exceptions.includes(attribute)) {
                const response = await this.$http.post(`${this.resource}`, {
                    id,
                    attribute,
                    value
                })
                if (response.data.success) {
                    this.$message.success(response.data.message)
                } else {
                    this.$message.error(response.data.message)
                }
            } else {

                let info = this.columns_header.filter(column => parseInt(column.id) === parseInt(id))
                let flag_client_type_document = false
                if (info.length > 0) {
                    info = info[0]
                    if (info.value === 'client_type_document') {
                        flag_client_type_document = true
                    }
                }
                
                if (this.timer) {
                    clearTimeout(this.timer)
                }
                const array_font_size = ['font_size_a5', 'font_size_a4', 'font_size_ticket_80', 'font_size_ticket_58', 'font_size_ticket_50']
                const is_font_size = array_font_size.includes(attribute)
                if (value.length > 0 || flag_client_type_document || is_font_size) {
                    const flag_numeric = attribute === 'width' || is_font_size
                    if (flag_numeric && value.trim().length > 0) {
                        const valid = /[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ]/.test(value)
                        if (valid) {
                            this.$message.info('El campo no permite letras')
                            return
                        }
                    }

                    this.timer = setTimeout(async () => {
                        const response = await this.$http.post(`${this.resource}`, {
                            id,
                            attribute,
                            value
                        })
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                        } else {
                            this.$message.error(response.data.message)
                        }
                    }, 500)
                } else {
                    this.$message.info('El campo no puede estar vacío')
                }
            }
        },

        async updateRecordOrder(id, attribute, value, dispatch = false) {
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(async () => {
                const response = await this.$http.post(`${this.resource}/update-order`, {
                    id,
                    attribute,
                    value,
                    dispatch
                })
                if (response.data.success) {
                    this.$message.success(response.data.message)
                    let send_array = dispatch ? this.columns_table_dispatch : this.columns_table
                    this.reorderOnlyFront(send_array, value, id, response.data.order_original_modificado, dispatch)
                } else {
                    this.$message.error(response.data.message)
                }
            }, 500)
        },

        reorderOnlyFront(array, order, id_updated, order_original_modificado, dispatch = false) {
            const data_reorder = array.map(item => {
                if (item.order == order && item.id != id_updated) {
                    item.order = order_original_modificado
                }
                return {
                    id: item.id,
                    origin_name: item.origin_name,
                    name: item.name,
                    width: item.width,
                    order: item.order,
                    is_visible: Boolean(item.is_visible),
                    space: item.space,
                    value: item.value,
                    align: item.align,
                    show_in_pdf: Boolean(item.show_in_pdf) || false,
                    show_in_pdfticket: Boolean(item.show_in_pdfticket) || false,
                    header_in_bold: Boolean(item.header_in_bold) || false,
                    content_in_bold: Boolean(item.content_in_bold) || false,
                }
            }).sort((a, b) => {
                return a.order - b.order
            })

            if (dispatch) {
                this.columns_table_dispatch = []
                this.columns_table_dispatch = data_reorder
            } else {
                this.columns_table = []
                this.columns_table = data_reorder
            }
        },

        updateRecordListColumnsHideShowCPE(value, show) {
            // en caso de guardar a db
        },

        isBackgroundOrColor(row) {
            const value = row.value
            const prefix = value.split('_')[0]
            const prefix_color = prefix + '_' + value.split('_')[1]
            const array_match_prefix = ['color', 'background']
            if (array_match_prefix.includes(prefix) || prefix_color === 'color_border') {
                return true
            }
            return false
        },

        showColorCompany(row) {
            const value = row.value
            const list_match = ['company_trade_name', 'company_name', 'document_type']
            if (list_match.includes(value)) {
                return true
            }
            return false
        },
        showChecksInColumnsCPE(value) {
            const array_match = [
                'item_image',
                'model',
                'unit_price',
                'total_base_igv',
                'total',
                'total_sin_igv'
            ]
            return array_match.includes(value)
        }
    },

}

</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/document_columns/index.vue